import { createFragmentContainer, graphql } from "react-relay";
import JobEvent from "../JobEvent";

type Props = {
  event: any;
  previousTimestamp: string | null | undefined;
};

function JobEventAgentStopped({ event, previousTimestamp }: Props) {
  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>Agent Stopped</JobEvent.Label>
      <JobEvent.Description>
        The agent was stopped and so the job was re-scheduled.
      </JobEvent.Description>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventAgentStopped, {
  event: graphql`
    fragment JobEventAgentStopped_event on JobEvent {
      ... on JobEvent {
        timestamp
      }
    }
  `,
});
